var ReportStatuses = new Enum({
  None: 0,
  InProcess: 1,
  Ready: 2,
  Interrupted: 3
});
